export enum AUTH_MODE {
  LOADING_ACCOUNTS,
  SELECT_ACCOUNT,
  CHECKING_ACCOUNT_STATUS,
  ACCOUNT_SELECTED
}
